import React from 'react';
import './footer_last.scss';
// import Button from '@material-ui/core/Button';
import { Container } from '@material-ui/core';
import LogoGreen from './../../img/logo_green.svg';
const FooterLast = () => {
  return (
    <div className="App_footer_last">
      <Container maxWidth="xl">
        <img alt="iTrust logo in green" src={LogoGreen} />
        <p>iTrust&nbsp;Finance®</p>
        <p>© 2021 iTrust.Finance</p>
      </Container>
    </div>
  );
};

export default FooterLast;
